<template>
  <v-flex
    id="importantNeeds"
    class="question"
  >
    <h2
      class="header"
      :class="{ required: getImportantNeedsQuestions.required }"
    >
      {{ getImportantNeedsQuestions.label }}
    </h2>
    <p class="mb-0">
      {{ $t('sheet.sheet_two.important_needs.hint_1') }}
      <a
        target="_blank"
        :href="links?.IMPORTANT_NEEDS_INFO"
      >{{
        $t('sheet.sheet_two.important_needs.link_1')
      }}</a>
    </p>
    <p class="mb-0">
      {{ $t('sheet.sheet_two.important_needs.hint_2') }}
    </p>
    <v-layout wrap>
      <v-flex
        v-for="(item, index) in list"
        :key="index"
        xs12
        class="mt-3 mb-2"
      >
        <v-layout>
          <v-flex
            class="mt-4 mr-2"
            shrink
          >
            <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
          </v-flex>
          <v-flex>
            <v-layout wrap>
              <v-flex
                v-if="getImportantNeedsQuestions.hasOwnProperty('need')"
                lg5
              >
                <v-textarea
                  v-model="item.need"
                  v-validate="{ ...requiredRegularField(getImportantNeedsQuestions.need.required) }"
                  :label="getImportantNeedsQuestions.need.label"
                  :error-messages="errors.collect(createDataName('importantNeeds', index))"
                  :data-vv-as="$t('sheet.sheet_two.important_needs.labels.needs')"
                  :data-vv-name="createDataName('importantNeeds', index)"
                  :required="getImportantNeedsQuestions.need.required"
                  :disabled="readOnly"
                  :rows="1"
                  auto-grow
                  @blur="completePersonData(index)"
                  @focus="falseComplete(index)"
                />
              </v-flex>
              <v-flex
                v-if="getImportantNeedsQuestions.hasOwnProperty('note')"
                xs12
                class="mt-3"
              >
                <v-textarea
                  v-model="item.note"
                  v-validate="{ ...requiredRegularField(!item?.noteNotNeeded) }"
                  :label="getImportantNeedsQuestions.note.label"
                  :class="{ 'v-text-field--greyed-out': item?.noteNotNeeded }"
                  :error-messages="errors.collect(createDataName('importantNote', index))"
                  :data-vv-as="$t('sheet.sheet_two.important_needs.labels.note')"
                  :data-vv-name="createDataName('importantNote', index)"
                  :required="!item?.noteNotNeeded"
                  auto-grow
                  :disabled="readOnly || item?.noteNotNeeded"
                  @blur="completePersonData(index)"
                  @focus="falseComplete(index)"
                />
              </v-flex>
              <v-flex
                v-if="getImportantNeedsQuestions.hasOwnProperty('note_not_needed')"
                xs12
                class="mt-3"
              >
                <v-checkbox
                  v-model="item.noteNotNeeded"
                  :label="getImportantNeedsQuestions.note_not_needed.label"
                  data-vv-name="note_not_needed"
                  :disabled="readOnly"
                  type="checkbox"
                  off-icon=""
                  on-icon="check"
                  @change="clearNote(index)"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider class="my-4" />
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import links from '@/constants/links';
import validationRules from '@/constants/validationRules';
import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'sheet/getImportantNeedsFields',
    mutationType: 'sheet/updateImportantNeedsField'
});

export default {
    name: 'ImportantNeeds',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            completed: [false, false, false],
            links
        };
    },
    computed: {
        ...mapFields(['list']),
        ...mapGetters('sheet', ['getImportantNeedsQuestions'])
    },
    methods: {
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, id) {
            return name + id;
        },
        completePersonData (index) {
            const _keys = [];
            Object.keys(this.fields).forEach((key) => {
                if (key.indexOf(index) !== -1) {
                    _keys.push(this.fields[key]);
                }
            });
            this.completed[index] = Object.keys(_keys).every((key) => _keys[key].valid);
        },
        falseComplete (index) {
            this.completed[index] = false;
        },
        clearNote (index) {
            if (!this?.list?.[index]?.note) return;
            this.list[index].note = '';
        }
    }
};
</script>

<style scoped lang="scss"></style>
